/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AwsServiceUploadPresignMultyResponse } from './AwsServiceUploadPresignMultyResponse';

export type AwsServiceUploadPresignMultyResponseApiRespoonse = {
    data?: AwsServiceUploadPresignMultyResponse;
    status?: AwsServiceUploadPresignMultyResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AwsServiceUploadPresignMultyResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

